import styled from 'styled-components';
import { lightenHex } from '../utils/annotationPresentation';

export const MarkerContainer = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  pointer-events: auto;
  z-index: 15;
  cursor: pointer;

  &:hover {
    z-index: 20;
  }
`;

// Pennant flag marking a point-in-time annotation. A short pole with a
// swallow-tailed flag, drawn in the annotation's type colour. Lifts slightly on
// hover; overflow is visible so the flag can extend past the SVG box.
export const FlagSvg = styled.svg`
  display: block;
  overflow: visible;
  transition: transform 0.15s ease, filter 0.15s ease;

  &:hover {
    transform: scale(1.12);
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.25));
  }
`;

export const AnnotationLine = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: ${props => props.height}px;
  background-color: ${props => lightenHex(props.color, 40)};
  opacity: 0.45;
  transform: translateX(-50%);
  display: ${props => (props.show ? 'block' : 'none')};
`;
